import "../App.css";

function HowToDeleteData() {
  return (
    <div className="App">
      <h1>ユーザーデータの削除方法について</h1>

      <h2>投稿の削除方法</h2>
      <p>以下の手順で自分の投稿を削除することができます。</p>
      <ol>
        <li>投稿画面を表示</li>
        <li>右上のアイコンをタップする</li>
        <li>「削除」を選択</li>
        <li>「投稿を削除しますか？」で「削除」を選択</li>
      </ol>
      <br />
      <h2>アカウント削除方法</h2>
      <p>以下の手順でアカウント及び全投稿データを削除することができます。</p>
      <ol>
        <li>下部のタブの一番右端をタップしプロフィール画面に移動する</li>
        <li>右上の歯車マークをタップする</li>
        <li>「その他」を選択</li>
        <li>「アカウントの削除」を選択</li>
        <li>「アカウントを削除する」を選択</li>
      </ol>

      <br />

      <p>以上</p>
    </div>
  );
}

export default HowToDeleteData;
